export default "__VITE_ASSET__Bye1YE$A__"